$(function(){

});

loadMore = (e) =>{
  var $load_more_btn = $(e);

  var $collection_container = $('.ex-collection-grid');
  var $next_url = $load_more_btn.attr('data-next-url');

  var $load_more_spinner = $('.ex-load-more-spinner');
  $.ajax({
    url: $next_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function() {
      $load_more_btn.hide();
      $load_more_spinner.show();
    }
  }).done(function(d){
    $load_more_spinner.hide();
    var $new_products = $(d).find(".ex-collection-grid");
    var $new_url = $(d).find('.ex-load-more-btn').attr('data-next-url');

    var $urlSplit = $next_url.split('?');
    var $param = $urlSplit[$urlSplit.length-1];


    window.history.replaceState(null, null, `?${$param}`);
    $collection_container.append($new_products.children());
    $collection_container.addClass('pag-loaded');

    if($new_url){
      $load_more_btn.attr('data-next-url', $new_url);
      $load_more_btn.show();
    }
  }).fail(function(e){
    console.log('you',e);
  });
}

loadPrevious = (e) =>{
  var $load_previous_btn = $(e);

  var $collection_container = $('.ex-collection-grid');
  var $previous_url = $load_previous_btn.attr('data-previous-url');

  var $load_previous_spinner = $('.ex-load-previous-spinner');
  $.ajax({
    url: $previous_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function() {
      $load_previous_btn.hide();
      $load_previous_spinner.show();
    }
  }).done(function(d){
    $load_previous_spinner.hide();
    var $new_products = $(d).find(".ex-collection-grid");
    var $new_url = $(d).find('.ex-load-previous-btn').attr('data-previous-url');

    var $urlSplit = $previous_url.split('?');
    var $param = $urlSplit[$urlSplit.length-1];


    window.history.replaceState(null, null, `?${$param}`);
    $collection_container.prepend($new_products.children());
    $collection_container.addClass('pag-loaded');


    if($new_url){
      $load_previous_btn.attr('data-previous-url', $new_url);
      $load_previous_btn.show();
    }
  }).fail(function(e){
    console.log('you',e);
  });
}
